export const MB = 1024 * 1024;

// Unified limits (match backend chat rules + mobile app)
export const MAX_VIDEO_BYTES = 20 * MB; // 20 MB
export const MAX_FILE_BYTES = 20 * MB; // 20 MB (images, pdfs, everything else)

export function inferUploadKind(file) {
  const type = String(file?.type || "").toLowerCase();
  const name = String(file?.name || "").toLowerCase();

  if (type.startsWith("video/") || name.endsWith(".mp4") || name.endsWith(".mov") || name.endsWith(".avi")) return "video";
  if (type === "application/pdf" || name.endsWith(".pdf")) return "pdf";
  if (type.startsWith("image/") || name.endsWith(".jpg") || name.endsWith(".jpeg") || name.endsWith(".png") || name.endsWith(".gif"))
    return "image";
  return "file";
}

export function formatBytes(bytes) {
  if (!Number.isFinite(bytes) || bytes <= 0) return "0 MB";
  return `${(bytes / MB).toFixed(1)} MB`;
}

export function validateFileSize(file) {
  const kind = inferUploadKind(file);
  const limit = kind === "video" ? MAX_VIDEO_BYTES : MAX_FILE_BYTES;
  if (file.size <= limit) return { ok: true };

  const limitLabel = "20 MB";
  const typeLabel = kind === "video" ? "Video" : kind === "pdf" ? "PDF" : kind === "image" ? "Image" : "File";

  return {
    ok: false,
    title: "File too large",
    message: `${typeLabel} "${file.name}" is ${formatBytes(file.size)}. Maximum allowed is ${limitLabel}.`,
  };
}

export function validateFilesOrAlert(files, { alertFn } = {}) {
  const accepted = [];
  const rejected = [];

  for (const f of Array.from(files || [])) {
    const res = validateFileSize(f);
    if (res.ok) accepted.push(f);
    else rejected.push(res);
  }

  if (rejected.length > 0 && typeof alertFn === "function") {
    const lines = rejected.map((r) => `- ${r.message}`).join("\n");
    alertFn(`Some files were not added:\n\n${lines}`);
  }

  return { accepted, rejected };
}

